import React from 'react'
import Logo from '../assets/images/logo.png';

export const Header = () => {
  return (
     <header className="header">
      <div className="container">
        <div className="nav-wrapper">
          <div className="logo">
            <a href='/'>
                <img src={Logo} alt="Renew Workforce" className="logo-image" style={{ height: '82px' }} />
            </a>
          </div>
          <nav className="nav">
            <a href="#services" className="nav-link">Services</a>
            <a href="#jobs" className="nav-link">Jobs</a>
            <a href="#about" className="nav-link">About</a>
            <a href="#contact" className="nav-link">Contact</a>
          </nav>
          {/* <div className="nav-actions">
            <Button variant="outline" className="btn-secondary" >
              For Employers
            </Button>
            <a href="#jobs">
              <Button className="btn-primary">
                Career Opportunities
              </Button>
            </a>
          </div> */}
        </div>
      </div>
    </header>
  )
}
